// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.T7H5FuHtlilQEBHMVKFO {
  display: flex;
  flex: 1;
  flex-direction: column-reverse;
  padding: 0.5em;
  color: var(--text-color);
  font-size: 1em;
  font-weight: 400;
  font-family: var(--text-font);
  overflow-y: auto;
}

.T7H5FuHtlilQEBHMVKFO a {
  color: var(--link-color);
  text-decoration: underline;
}

.T7H5FuHtlilQEBHMVKFO p {
  margin: 0.2em;
  color: var(--text-color);
}

.T7H5FuHtlilQEBHMVKFO ul {
  margin: 0.2em;
  padding-left: 2em;
  color: var(--text-color);
}

.T7H5FuHtlilQEBHMVKFO ol {
  margin: 0.2em;
  padding-left: 2em;
  color: var(--text-color);
}

.T7H5FuHtlilQEBHMVKFO h1 {
  font-size: 1.5em;
  font-weight: 600;
  margin: 0.5em;
  color: var(--text-color);
}

.T7H5FuHtlilQEBHMVKFO h2 {
  font-size: 1.3em;
  font-weight: 600;
  margin: 0.5em;
  color: var(--text-color);
}

.T7H5FuHtlilQEBHMVKFO h3 {
  font-size: 1.1em;
  font-weight: 600;
  margin: 0.5em;
  color: var(--text-color);
}

.T7H5FuHtlilQEBHMVKFO h4 {
  font-size: 1em;
  font-weight: 600;
  margin: 0.5em;
  color: var(--text-color);
}

.T7H5FuHtlilQEBHMVKFO h5 {
  font-size: 0.9em;
  font-weight: 600;
  margin: 0.5em;
  color: var(--text-color);
}

.T7H5FuHtlilQEBHMVKFO h6 {
  font-size: 0.8em;
  font-weight: 600;
  margin: 0.5em;
  color: var(--text-color);
}

.cfL1Ytt0ExWPI76khvUt {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 0.5em;
  margin: 0.5em;
  border-radius: 10px;
  border-top-left-radius: 0px;
  background-color: var(--bot-color);
  max-width: 90%;
}

.swSwdANBAkQJ2f5cQS8f {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 0.5em;
  margin: 0.5em;
  border-radius: 10px;
  border-top-left-radius: 0px;
  background-color: var(--agent-color);
  max-width: 90%;
}

.HeORyDAs_CDvrinlwHXU {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 0.5em;
  margin: 0.5em;
  border-radius: 10px;
  border-top-right-radius: 0px;
  background-color: var(--user-color);
  max-width: 90%;
}

.mx9EXUr520_KBI9EIu4E {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1em;
  margin: 0;
  border-radius: 5px;
  background-color: transparent;
  color: var(--text-color);
  max-width: 90%;
}

.mx9EXUr520_KBI9EIu4E > p {
  margin: 0;
  color: var(--text-color);
  text-align: center;
}

.PP2SdAb0vMIYsmJqzTPt {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0.5em;
  gap: 0.5em;
  box-sizing: border-box;
  width: 100%;
  background-color: var(--card-color);
  height: 6em;
}

.PP2SdAb0vMIYsmJqzTPt > textarea {
  width: 100%;
  height: 100%;
  border: none;
  border-radius: var(--border-radius);
  resize: none;
  outline: none;
  font-size: 1em;
  font-family: var(--text-font);
  font-weight: 400;
  padding: 0.5em;
  display: flex;
  flex: 1;
  box-sizing: border-box;
  background-color: var(--input-color);
  color: var(--text-color);
}

.PP2SdAb0vMIYsmJqzTPt > textarea:disabled {
  cursor: not-allowed;
  background-color: var(--user-color);
}

.ksj4FQ13Db19UumYpAXT {
  padding: 14px 10px 0px 10px;
  transform: scale(0.3333);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.OirekOc3iMEZDJK_LQqk {
  position: relative;
  left: -9999px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: var(--text-color);
  color: var(--text-color);
  box-shadow:
    9984px 0 0 0 var(--text-color),
    9999px 0 0 0 var(--text-color),
    10014px 0 0 0 var(--text-color);
  animation: x2aE5kKWAbE8slZtKhyA 1.5s infinite linear;
}

@keyframes x2aE5kKWAbE8slZtKhyA {
  0% {
    box-shadow:
      9984px 0 0 0 var(--text-color),
      9999px 0 0 0 var(--text-color),
      10014px 0 0 0 var(--text-color);
  }
  16.667% {
    box-shadow:
      9984px -10px 0 0 var(--text-color),
      9999px 0 0 0 var(--text-color),
      10014px 0 0 0 var(--text-color);
  }
  33.333% {
    box-shadow:
      9984px 0 0 0 var(--text-color),
      9999px 0 0 0 var(--text-color),
      10014px 0 0 0 var(--text-color);
  }
  50% {
    box-shadow:
      9984px 0 0 0 var(--text-color),
      9999px -10px 0 0 var(--text-color),
      10014px 0 0 0 var(--text-color);
  }
  66.667% {
    box-shadow:
      9984px 0 0 0 var(--text-color),
      9999px 0 0 0 var(--text-color),
      10014px 0 0 0 var(--text-color);
  }
  83.333% {
    box-shadow:
      9984px 0 0 0 var(--text-color),
      9999px 0 0 0 var(--text-color),
      10014px -10px 0 0 var(--text-color);
  }
  100% {
    box-shadow:
      9984px 0 0 0 var(--text-color),
      9999px 0 0 0 var(--text-color),
      10014px 0 0 0 var(--text-color);
  }
}

.t3JdYoyaredMgYwHfTYO {
  color: #e20000;
  background-color: #e8e8e8;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 0.5em;
  margin: 0.5em;
  border-radius: 5px;
  max-width: 90%;
}

.Ke8yaeccyhNM88k1RJSR {
  color: gray;
  display: flex;
  font-size: smaller;
}
`, "",{"version":3,"sources":["webpack://./src/styles/ChatbotBox.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,OAAO;EACP,8BAA8B;EAC9B,cAAc;EACd,wBAAwB;EACxB,cAAc;EACd,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,UAAU;EACV,sBAAsB;EACtB,WAAW;EACX,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mCAAmC;EACnC,YAAY;EACZ,aAAa;EACb,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,wBAAwB;EACxB;;;mCAGiC;EACjC,oDAA0C;AAC5C;;AAEA;EACE;IACE;;;qCAGiC;EACnC;EACA;IACE;;;qCAGiC;EACnC;EACA;IACE;;;qCAGiC;EACnC;EACA;IACE;;;qCAGiC;EACnC;EACA;IACE;;;qCAGiC;EACnC;EACA;IACE;;;yCAGqC;EACvC;EACA;IACE;;;qCAGiC;EACnC;AACF;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;AACpB","sourcesContent":[".chatbotMessages {\n  display: flex;\n  flex: 1;\n  flex-direction: column-reverse;\n  padding: 0.5em;\n  color: var(--text-color);\n  font-size: 1em;\n  font-weight: 400;\n  font-family: var(--text-font);\n  overflow-y: auto;\n}\n\n.chatbotMessages a {\n  color: var(--link-color);\n  text-decoration: underline;\n}\n\n.chatbotMessages p {\n  margin: 0.2em;\n  color: var(--text-color);\n}\n\n.chatbotMessages ul {\n  margin: 0.2em;\n  padding-left: 2em;\n  color: var(--text-color);\n}\n\n.chatbotMessages ol {\n  margin: 0.2em;\n  padding-left: 2em;\n  color: var(--text-color);\n}\n\n.chatbotMessages h1 {\n  font-size: 1.5em;\n  font-weight: 600;\n  margin: 0.5em;\n  color: var(--text-color);\n}\n\n.chatbotMessages h2 {\n  font-size: 1.3em;\n  font-weight: 600;\n  margin: 0.5em;\n  color: var(--text-color);\n}\n\n.chatbotMessages h3 {\n  font-size: 1.1em;\n  font-weight: 600;\n  margin: 0.5em;\n  color: var(--text-color);\n}\n\n.chatbotMessages h4 {\n  font-size: 1em;\n  font-weight: 600;\n  margin: 0.5em;\n  color: var(--text-color);\n}\n\n.chatbotMessages h5 {\n  font-size: 0.9em;\n  font-weight: 600;\n  margin: 0.5em;\n  color: var(--text-color);\n}\n\n.chatbotMessages h6 {\n  font-size: 0.8em;\n  font-weight: 600;\n  margin: 0.5em;\n  color: var(--text-color);\n}\n\n.chatbotBubbleBot {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  padding: 0.5em;\n  margin: 0.5em;\n  border-radius: 10px;\n  border-top-left-radius: 0px;\n  background-color: var(--bot-color);\n  max-width: 90%;\n}\n\n.chatbotBubbleAgent {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  padding: 0.5em;\n  margin: 0.5em;\n  border-radius: 10px;\n  border-top-left-radius: 0px;\n  background-color: var(--agent-color);\n  max-width: 90%;\n}\n\n.chatbotBubbleUser {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  padding: 0.5em;\n  margin: 0.5em;\n  border-radius: 10px;\n  border-top-right-radius: 0px;\n  background-color: var(--user-color);\n  max-width: 90%;\n}\n\n.chatbotBubbleSystem {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 1em;\n  margin: 0;\n  border-radius: 5px;\n  background-color: transparent;\n  color: var(--text-color);\n  max-width: 90%;\n}\n\n.chatbotBubbleSystem > p {\n  margin: 0;\n  color: var(--text-color);\n  text-align: center;\n}\n\n.chatbotInput {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  padding: 0.5em;\n  gap: 0.5em;\n  box-sizing: border-box;\n  width: 100%;\n  background-color: var(--card-color);\n  height: 6em;\n}\n\n.chatbotInput > textarea {\n  width: 100%;\n  height: 100%;\n  border: none;\n  border-radius: var(--border-radius);\n  resize: none;\n  outline: none;\n  font-size: 1em;\n  font-family: var(--text-font);\n  font-weight: 400;\n  padding: 0.5em;\n  display: flex;\n  flex: 1;\n  box-sizing: border-box;\n  background-color: var(--input-color);\n  color: var(--text-color);\n}\n\n.chatbotInput > textarea:disabled {\n  cursor: not-allowed;\n  background-color: var(--user-color);\n}\n\n.dotTypingContainer {\n  padding: 14px 10px 0px 10px;\n  transform: scale(0.3333);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n\n.dotTyping {\n  position: relative;\n  left: -9999px;\n  width: 10px;\n  height: 10px;\n  border-radius: 5px;\n  background-color: var(--text-color);\n  color: var(--text-color);\n  box-shadow:\n    9984px 0 0 0 var(--text-color),\n    9999px 0 0 0 var(--text-color),\n    10014px 0 0 0 var(--text-color);\n  animation: dot-typing 1.5s infinite linear;\n}\n\n@keyframes dot-typing {\n  0% {\n    box-shadow:\n      9984px 0 0 0 var(--text-color),\n      9999px 0 0 0 var(--text-color),\n      10014px 0 0 0 var(--text-color);\n  }\n  16.667% {\n    box-shadow:\n      9984px -10px 0 0 var(--text-color),\n      9999px 0 0 0 var(--text-color),\n      10014px 0 0 0 var(--text-color);\n  }\n  33.333% {\n    box-shadow:\n      9984px 0 0 0 var(--text-color),\n      9999px 0 0 0 var(--text-color),\n      10014px 0 0 0 var(--text-color);\n  }\n  50% {\n    box-shadow:\n      9984px 0 0 0 var(--text-color),\n      9999px -10px 0 0 var(--text-color),\n      10014px 0 0 0 var(--text-color);\n  }\n  66.667% {\n    box-shadow:\n      9984px 0 0 0 var(--text-color),\n      9999px 0 0 0 var(--text-color),\n      10014px 0 0 0 var(--text-color);\n  }\n  83.333% {\n    box-shadow:\n      9984px 0 0 0 var(--text-color),\n      9999px 0 0 0 var(--text-color),\n      10014px -10px 0 0 var(--text-color);\n  }\n  100% {\n    box-shadow:\n      9984px 0 0 0 var(--text-color),\n      9999px 0 0 0 var(--text-color),\n      10014px 0 0 0 var(--text-color);\n  }\n}\n\n.errorMessage {\n  color: #e20000;\n  background-color: #e8e8e8;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  padding: 0.5em;\n  margin: 0.5em;\n  border-radius: 5px;\n  max-width: 90%;\n}\n\n.timestamp {\n  color: gray;\n  display: flex;\n  font-size: smaller;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chatbotMessages": `T7H5FuHtlilQEBHMVKFO`,
	"chatbotBubbleBot": `cfL1Ytt0ExWPI76khvUt`,
	"chatbotBubbleAgent": `swSwdANBAkQJ2f5cQS8f`,
	"chatbotBubbleUser": `HeORyDAs_CDvrinlwHXU`,
	"chatbotBubbleSystem": `mx9EXUr520_KBI9EIu4E`,
	"chatbotInput": `PP2SdAb0vMIYsmJqzTPt`,
	"dotTypingContainer": `ksj4FQ13Db19UumYpAXT`,
	"dotTyping": `OirekOc3iMEZDJK_LQqk`,
	"dot-typing": `x2aE5kKWAbE8slZtKhyA`,
	"errorMessage": `t3JdYoyaredMgYwHfTYO`,
	"timestamp": `Ke8yaeccyhNM88k1RJSR`
};
export default ___CSS_LOADER_EXPORT___;
